/** PURE_IMPORTS_START .._.._Observable,.._.._observable_zip PURE_IMPORTS_END */
import { Observable } from '../../Observable';
import { zip as zipStatic } from '../../observable/zip';
Observable.zip = zipStatic;
//# sourceMappingURL=zip.js.map 



//////////////////
// WEBPACK FOOTER
// ./node_modules/rxjs/_esm5/add/observable/zip.js
// module id = ./node_modules/rxjs/_esm5/add/observable/zip.js
// module chunks = vendor